module.exports = __webpack_public_path__ + "img/recommended-demo.7165127.gif";